// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2DZoJ","note":"styles_note__1uykX","list":"styles_list__3BWqa","inputFile":"styles_inputFile__TJ2bF","close":"styles_close__237TC"};